import { Component, input, output, signal, effect } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EvTooltipImgModule } from "ev-tooltip-img";
import { EvTooltipModule } from "ev-tooltip";
import { SergeantTitleComponent } from "src/app/infopage/components/sergeant-title/sergeant-title.component";
import { EnergyLabelSingle } from "src/models/common/energylabel.model";
import { EnergyLabelVersion } from "src/models/common/energy.enums";

@Component({
    selector: "single-energy-label",
    templateUrl: "./single-energy-label.component.html",
    styleUrl: "./single-energy-label.component.scss",
    imports: [CommonModule, EvTooltipImgModule, EvTooltipModule, SergeantTitleComponent],
})
export class SingleEnergyLabelComponent {
    scoreTooltipOpen: boolean = false;
    greenEnergyTooltipImgUrl = "assets/images/img-gronnbolig.jpg";
    greenEnergyTooltipVisible = signal(false);
    readonly greenHomeArticleUrl = "https://home.eiendomsverdi.no/artikler/gr%C3%B8nn-bolig";
    EnergyLabelVersion = EnergyLabelVersion;

    expandDetailsClicked = output<void>();

    energyRating = input.required<EnergyLabelSingle>();
    isGreenHome = input.required<boolean>();
    greenHomeDescription = input.required<string>();

    showGreenEnergyTooltip() {
        this.greenEnergyTooltipVisible.set(true);
    }
    hideGreenEnergyTooltip() {
        this.greenEnergyTooltipVisible.set(false);
    }
    closeScoreInformation() {
        this.scoreTooltipOpen = false;
    }
    openScoreInformation($event: Event) {
        if (this.scoreTooltipOpen === false) {
            this.scoreTooltipOpen = true;
            $event.stopPropagation();
        }
    }
    goToEnergyUsage() {
        this.expandDetailsClicked.emit();
    }
}
